import { render, staticRenderFns } from "./CookiesBar.vue?vue&type=template&id=67c037f1&"
import script from "./CookiesBar.vue?vue&type=script&lang=js&"
export * from "./CookiesBar.vue?vue&type=script&lang=js&"
import style0 from "./CookiesBar.vue?vue&type=style&index=0&id=67c037f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports